import { createSelector } from "reselect"

const getPersonsCurrent = (state) =>
  state.project.dates[state.project.dateStatusCurrent].persons

const getOptionsPersons = createSelector(
  [getPersonsCurrent],
  (personsCurrent) => {
    let optionsPersons = Object.keys(personsCurrent)
      .slice()
      .sort((a, b) => {
        return personsCurrent[a].nameDisplayShort >
          personsCurrent[b].nameDisplayShort
          ? 1
          : personsCurrent[b].nameDisplayShort >
            personsCurrent[a].nameDisplayShort
          ? -1
          : 0
      })
      .map((rId) => ({
        value: rId,
        label: personsCurrent[rId].nameDisplayShort,
      }))

    return optionsPersons
  }
)

export default getOptionsPersons
